import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { SharedService } from '../../modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import config from 'config/default.json';
import { ApiServiceModule } from '../../modules/api-service.module';
import { HelperModule } from '../../modules/helper.module';
import { MailSenderComponent } from './mail-sender/mail-sender.component';

@Component({
  selector: 'app-student-manager',
  templateUrl: './student-manager.component.html',
  styleUrls: ['./student-manager.component.scss', '../../components/table/table.component.scss']
})
export class StudentManagerComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Output() inProgress = new EventEmitter<any>();
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() data:{[x: string]: any}[] = [];
  @Input() platformInfos: { [x:string]: any } = new Map();
  platforms: any[] = [];

  ngOnInit() {
    this.buildData();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.buildData();
    }
  }
  buildData(){
    this.dataSource = this.data.map((row:any) => {
      row["expanded"] = false;
      row["checked"] = false;
      return row;
    });
    this.showedRows = this.dataSource;
    this.platforms = Array.from(new Set(this.data.map((el:any)=>el.platform)));
  }
  toggleRow(row:any, clickedElm:any){
    if(clickedElm.tagName != 'INPUT'){
      row['expanded'] = !row['expanded'];
    }
  }
  studentSetting(){
    let selectedRows = this.selectRows();
    if(selectedRows.length){
      const dialogRef = this.dialog.open(MailSenderComponent, {
        width: '80%',
        position: {top: '30px' },
        data: {user_infos: this.userInfos, selected_rows: selectedRows, platform_infos: this.platformInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
      
      });
    }else this.helper.showToast('Select contents first...');
  }
  
  


  sendData(checkedAllRef:any){

    //console.log(this.selectedRows);
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
